import { Static, Type } from '@sinclair/typebox'

export const AdminUser = Type.Object({
    id: Type.String(),
    firstName: Type.String(),
    lastName: Type.String(),
    email: Type.String(),
    externalId: Type.Union([Type.String(), Type.Null()]),
    tenantId: Type.String(),
    externalCustomerId: Type.Union([Type.String(), Type.Null()]),
    status: Type.String(),
    isInternalKizeo: Type.Boolean(),
    globalCode: Type.Optional(Type.String()),
})

export type AdminUser = Static<typeof AdminUser>

export const ListAdminUsersRequest = Type.Object({
    cursor: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Number({ default: 20 })),
    search: Type.Optional(Type.String()),
    status: Type.Optional(Type.Array(Type.String())),
    externalId: Type.Optional(Type.String()),
    externalCustomerId: Type.Optional(Type.String()),
    tenantId: Type.Optional(Type.String()),
    isInternalKizeo: Type.Optional(Type.Boolean()),
})

export type ListAdminUsersRequest = Static<typeof ListAdminUsersRequest>

export const GetAdminUserParams = Type.Object({
    id: Type.String(),
})

export type GetAdminUserParams = Static<typeof GetAdminUserParams>
